<template>
  <SelectableGridInput v-model="selectedPaletteId" :items="palettes" :showSelectionPreview="false">
    <template #header>
      <h2 class="text-xl font-semibold">{{ t("ui.inputs.chooseColorPalette") }}</h2>
    </template>

    <template #item="{ item }">
      <div class="flex gap-2">
        <div
          v-for="color in item.colors"
          :key="color"
          class="w-6 h-6 rounded-full border border-base-content/10"
          :style="{ backgroundColor: color }"></div>
      </div>
      <span class="text-sm font-medium text-gray-600">{{ t(`ui.inputs.paletteNames.${item.id}`) }}</span>
    </template>
  </SelectableGridInput>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import SelectableGridInput from "./SelectableGridInput.vue";
import { SelectableItemDto } from "@/features/blueprint/dtos/SelectableItemDto";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps<{
  modelValue: string | null;
}>();
interface PaletteScheme extends SelectableItemDto {
  name: string;
  colors: [string, string, string, string];
}
const palettes: PaletteScheme[] = [
  { id: "ocean", name: "Ocean Breeze", colors: ["#2B6777", "#4C9F9F", "#F7C59F", "#ECECEC"] },
  { id: "sunset", name: "Sunset Glow", colors: ["#D1495B", "#EDAE49", "#EDE3D9", "#C9CCD5"] },
  { id: "mint", name: "Cool Mint", colors: ["#2E8B57", "#3CB371", "#F5F5DC", "#696969"] },
  { id: "sage", name: "Muted Sage", colors: ["#6B8E23", "#9ACD32", "#F5DEB3", "#FAF0E6"] },
  { id: "berry", name: "Berry Pop", colors: ["#6A0DAD", "#E0115F", "#FFE5B4", "#2F4F4F"] },
  { id: "sky", name: "Sky High", colors: ["#87CEEB", "#4682B4", "#FFFFFF", "#1C1C1C"] },
];

const selectedPaletteId = ref<string | null>(props.modelValue ?? palettes[0].id);

watch(
  () => props.modelValue,
  val => {
    selectedPaletteId.value = val ?? palettes[0].id;
  }
);
const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();
watch(selectedPaletteId, id => {
  emit("update:modelValue", id!);
});
</script>
